import { Image } from "antd";
import moment from "moment";
import { mConstants } from "../../../../../helper/constants";
import { MComment } from "../../entity/product.model";

export interface CCommentProps {
  comment: MComment;
}

function CComment(props: CCommentProps) {
  return (
    <div>
      <div className="media flex-column flex-md-row">
        <div className="mr-md-3 mb-2 mb-md-0">
          <a href="#">
            <img
              src="/assets/limitless/global_assets/images/placeholders/placeholder.jpg"
              className="rounded-circle"
              width={36}
              height={36}
              alt=""
            />
          </a>
        </div>
        <div className="media-body">
          <div className="media-title">
            <a href="#" className="font-weight-semibold">
              {props.comment.username}
            </a>
            <span className="font-size-sm text-muted ml-sm-2 mb-2 mb-sm-0 d-block d-sm-inline-block">
              {moment(props.comment.createdDate).format(
                mConstants.DATETIME_FORMAT
              )}
            </span>
          </div>
          <p>{props.comment.content}</p>
        </div>
      </div>
      <div className="row">
        {props.comment.commentUploads?.map((commentUpload) => {
          return (
            <div className="col-xl-3 col-sm-6" key={commentUpload.uuid}>
              <div className="card">
                <div className="card-img-actions mx-1 mt-1">
                  <Image
                    className="card-img img-fluid"
                    src={commentUpload.file}
                  />
                </div>
                <div className="card-body p-2">
                  <div className="d-flex align-items-start flex-wrap">
                    <div className="font-size-xs">{commentUpload.filePath}</div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CComment;
